/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import UInt64DTO from './UInt64DTO';





/**
* The CommunicationTimestamps model module.
* @module model/CommunicationTimestamps
* @version 0.7.15
*/
export default class CommunicationTimestamps {
    /**
    * Constructs a new <code>CommunicationTimestamps</code>.
    * @alias module:model/CommunicationTimestamps
    * @class
    */

    constructor() {
        

        
        

        

        
    }

    /**
    * Constructs a <code>CommunicationTimestamps</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CommunicationTimestamps} obj Optional instance to populate.
    * @return {module:model/CommunicationTimestamps} The populated <code>CommunicationTimestamps</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunicationTimestamps();

            
            
            

            if (data.hasOwnProperty('sendTimestamp')) {
                obj['sendTimestamp'] = UInt64DTO.constructFromObject(data['sendTimestamp']);
            }
            if (data.hasOwnProperty('receiveTimestamp')) {
                obj['receiveTimestamp'] = UInt64DTO.constructFromObject(data['receiveTimestamp']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/UInt64DTO} sendTimestamp
    */
    sendTimestamp = undefined;
    /**
    * @member {module:model/UInt64DTO} receiveTimestamp
    */
    receiveTimestamp = undefined;








}


